import { Controller } from '@hotwired/stimulus';
import { ref } from '@vue/reactivity';
import { useEventListener } from 'stimulus-library/dist';

export default class extends Controller {
  get parsedValue() {
    if (this.element instanceof HTMLInputElement && this.element.type === 'checkbox') {
      if (!this.element.checked) {
        return 0;
      }
      return parseInt(this.element.dataset.reactiveValueOverride || this.element.value, 10);
    }
    return parseInt(this.element.value, 10);
  }

  connect() {
    this.reactiveValue = ref(this.parsedValue);
    this.element.reactiveValue = this.reactiveValue;
    this.element.setAttribute('data-reactive-value', 'true');
    useEventListener(this, this.element, 'change', () => {
      this.reactiveValue.value = this.parsedValue;
    });
  }
}
